import * as Linking from "expo-linking";
import { Platform, Share } from "react-native";
import Toast from "react-native-toast-message";

export function buildTutorProfileShareUrl(tutorId: string): string {
  const path = `/home/find-tutor/${tutorId}`;

  if (Platform.OS === "web" && typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin.replace(/\/$/, "")}${path}`;
  }

  return Linking.createURL(path);
}

export async function shareTutorProfile(params: {
  tutorId: string;
  tutorName: string;
}): Promise<void> {
  const url = buildTutorProfileShareUrl(params.tutorId);
  const message = `Check out ${params.tutorName} on Loopedin`;

  if (Platform.OS === "web") {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({
          title: params.tutorName,
          text: message,
          url,
        });
        return;
      } catch (error) {
        if (error instanceof Error && error.name === "AbortError") return;
      }
    }

    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      Toast.show({
        type: "success",
        text1: "Link copied",
        text1Style: {
          fontFamily: "Geologica_400Regular",
          fontSize: 10,
          color: "#000000",
        },
      });
      return;
    }

    throw new Error("Sharing is not supported on this device");
  }

  await Share.share({
    message: `${message}\n${url}`,
    url,
    title: params.tutorName,
  });
}
